export var RepaymentOptions;
(function (RepaymentOptions) {
    RepaymentOptions["Downsize"] = "DOWNSIZE";
    RepaymentOptions["RelyOnCoApplicantsIncome"] = "RELY_ON_CO_APPLICANTS_INCOME";
    RepaymentOptions["RepayLoanBeforeRetirement"] = "REPAY_LOAN_BEFORE_RETIREMENT";
    RepaymentOptions["SellAssets"] = "SELL_ASSETS";
    RepaymentOptions["UseIncomeFromOtherInvestments"] = "USE_INCOME_FROM_OTHER_INVESTMENTS";
    RepaymentOptions["UseSavings"] = "USE_SAVINGS";
    RepaymentOptions["UseSuperannuationLumpSum"] = "USE_SUPERANNUATION_LUMP_SUM";
    RepaymentOptions["UseSuperannuationOnGoing"] = "USE_SUPERANNUATION_ONGOING";
    RepaymentOptions["WorkPastRetirementAge"] = "WORK_PAST_RETIREMENT_AGE";
    RepaymentOptions["Other"] = "OTHER";
})(RepaymentOptions || (RepaymentOptions = {}));
//# sourceMappingURL=RepaymentOptions.js.map